import { IThemePaletteKeys } from '@local/theme';

export const DEFAULT_PROVIDER_DIALOG_DURATION_ELEMENT = 0.3;
export const DEFAULT_PROVIDER_DIALOG_DURATION_LAYOUT = 0.4;
export const DEFAULT_PROVIDER_DIALOG_ELEMENT_MAX_HEIGHT: string = 'max-content';
export const DEFAULT_PROVIDER_DIALOG_ELEMENT_MAX_WIDTH: string = 'max-content';
export const DEFAULT_PROVIDER_DIALOG_ELEMENT_BORDER_RADIUS: string = '12px';
export const DEFAULT_PROVIDER_DIALOG_ELEMENT_PADDING: string = '20px';
export const DEFAULT_PROVIDER_DIALOG_ELEMENT_BACKGROUND: IThemePaletteKeys = 'whiteStandard';
